// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractSimpleModuleUi } from '../_abstract/ui';
/**
 * Component capable of rendering the `ParagraphModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let ParagraphModuleUi = class ParagraphModuleUi extends AbstractSimpleModuleUi {
};
ParagraphModuleUi = __decorate([
    Component({
        name: 'ParagraphModuleUi',
        template: '<component :is="component" class="paragraph-module" />'
    })
], ParagraphModuleUi);
export { ParagraphModuleUi };
